import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  share() {
    if (navigator.share) {
      navigator.share({
        title: document.title,
        url: window.location.href
      }).catch(err => {
        // User cancelled or error occurred
        console.log('Share cancelled or failed:', err)
      })
    } else {
      // Fallback: copy to clipboard
      navigator.clipboard.writeText(window.location.href).then(() => {
        this.showToast('Link copied to clipboard!')
      }).catch(err => {
        console.error('Failed to copy:', err)
        this.showToast('Failed to copy link')
      })
    }
  }

  filterByType(event) {
    const type = event.currentTarget.dataset.type || "all"
    document.dispatchEvent(new CustomEvent("book-contents:filter-type", {
      bubbles: true,
      detail: { type }
    }))
  }

  showToast(message) {
    // Simple toast notification
    const toast = document.createElement('div')
    toast.className = 'toast-notification'
    toast.textContent = message
    document.body.appendChild(toast)
    
    setTimeout(() => toast.classList.add('show'), 10)
    setTimeout(() => {
      toast.classList.remove('show')
      setTimeout(() => toast.remove(), 300)
    }, 2000)
  }
}
